import Header from "./components/Header";
import HeroContenidoAds from "./components/HeroContenidoAds";
import ServiciosContenidoAds from "./components/ServiciosContenidoAds";
import WhyUsContenidoAds from "./components/WhyUsContenidoAds";
import PlanesContenidoAds from "./components/PlanesContenidoAds";
import ProcesoContenidoAds from "./components/ProcesoContenidoAds";
import CasosExitoContenidoAds from "./components/CasosExitoContenidoAds";
import IndicadorAds from "./components/IndicadorAds";
import FAQContenidoAds from "./components/FAQContenidoAds";
import CTAFinalContenidoAds from "./components/CTAFinalContenidoAds";
import FooterSimpleContenidoAds from "./components/FooterSimpleContenidoAds";
import "./styles/App.scss";

function App() {

  return (
    <div>
      <Header />
      <HeroContenidoAds />
      <WhyUsContenidoAds />
      <ServiciosContenidoAds />
      <PlanesContenidoAds />
      <ProcesoContenidoAds />
      <CasosExitoContenidoAds />
      <IndicadorAds />
      <FAQContenidoAds />
      <CTAFinalContenidoAds />
      <FooterSimpleContenidoAds />
    </div>
  );
}

export default App;
